import * as React from 'react';
import styled from 'styled-components';
import BannerLink from '../../atoms/BannerLink';
import ThemeWindow from '../../atoms/ThemeWindow'
// styles

const Thema = styled.div`
  width: 302px;
  height: 389px;
  float: right;
  position: relative;
  border-left: 1px solid #fff;
  background-color: #005daa;
  & ul {
    width: 285px;
    height: 370px;
    position: absolute;
    top: 50%;
    margin-top: -185px;
    left: 50%;
    margin-left: -142px;
  }
  & li {
    width: 285px;
    margin: 0 auto 3px auto;
    line-height: 0;
    & :last-child {
      margin-bottom: 0;
    }
  }
`;

// markup
const ThemeImage = () => {
  return (
    <Thema>
      <ul>
        <li>
            <ThemeWindow imageLink='/images/theme.svg'/>
        </li>
        <li>
        <BannerLink link='/documents/2020-2021_theme01.pdf' bannerImage='/images/chairman.jpg' />
        </li>
        <li>
          <BannerLink link='/documents/2020-2021_theme02.pdf' bannerImage='/images/governor.jpg' />
        </li>
      </ul>
    </Thema>
  );
};

export default ThemeImage;
